<template>
  <v-dialog
    max-width="450px"
    :value="showDialog"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card class="ma-0 pa-0">
      <v-card-title class="py-4 px-6">
        <p class="blue-grey--text text--darken-3 h6 ma-0 pa-0">
          {{ title }}
        </p>
      </v-card-title>
      <v-card-text class="ma-0 py-0 px-6 pt-3">
        <v-form v-model="form.valid" ref="create_form">
          <v-text-field
            required
            outlined
            dense
            data-private
            autofocus
            v-model="name"
            :hide-details="Boolean(name)"
            :rules="[
              name => !!name || $t('validation.form.this_field_is_required'),
            ]"
            :label="`${$t('common.name')}*`"
          />
        </v-form>
      </v-card-text>
      <v-divider class="mt-6 mb-4" />
      <v-card-actions class="ma-0 pa-0 d-flex justify-end pb-4 px-6">
        <Button
          plain
          color="blueGrey"
          class="me-2"
          :disabled="loading"
          :text="$t('common.button.cancel')"
          @click="closeDialog"
        />
        <Button
          color="primary"
          :loading="loading"
          :disabled="loading"
          :text="$t('common.button.save')"
          @click="handleSave"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Button from '@/components/UI/Button'

export default {
  name: 'CreateModal',

  props: {
    title: { type: String, required: true },
    loading: { type: Boolean, required: true },
    showDialog: { type: Boolean, required: true },
  },
  components: {
    Button,
  },

  data() {
    return {
      form: {
        valid: true,
      },
      name: '',
    }
  },

  methods: {
    handleSave() {
      this.$refs.create_form.validate()
      if (!this.form.valid) return
      this.$emit('save', { name: this.name })
      this.resetForm()
    },

    resetForm() {
      this.name = ''
      this.$refs?.create_form?.reset?.()
    },

    closeDialog() {
      this.resetForm()
      this.$emit('close')
    },
  },
}
</script>
